





















































































































































































































import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import { mdiProjector } from "@mdi/js";
import imagePlaceholder from "@/components/img-placeholder.vue";
import api from "@/plugins/api";
import { mediumImageStyle as getMediumImageStyle } from "@/domain/event-medium";

interface MediaType {
  label: string;
  archiveStatus: string;
  archiveProgress: string;
  archiveUrl: string;
  archiveMessage: string;
  timeout: number;
  queryParameter: string;
}

@Component({
  components: {
    "img-placeholder": imagePlaceholder
  }
})
export default class Photowall extends Vue {
  slideshowIcon = mdiProjector;
  mediumImageStyle = getMediumImageStyle;

  // Button template array
  mediaTypes: MediaType[] = [
    {
      label: "Images",
      archiveStatus: "",
      archiveProgress: "0%",
      archiveUrl: "",
      archiveMessage: "",
      timeout: 0,
      queryParameter: "images"
    },
    {
      label: "Videos",
      archiveStatus: "",
      archiveProgress: "0%",
      archiveUrl: "",
      archiveMessage: "",
      timeout: 0,
      queryParameter: "videos"
    }
  ];

  get fluid() {
    return vxm.app.fluid;
  }

  get media() {
    return vxm.results.media;
  }

  get allMedia() {
    return vxm.results.allMedia;
  }

  get teams() {
    return vxm.results.teams;
  }

  get tasks() {
    return vxm.games.db[vxm.results.gameId].tasks
      .map((task, index) => ({
        id: task.id,
        text: `${index + 1}. ${task.text.replace(/<.*?>/g, "")}`,
        isMediaType: ["photo", "video", "augmentedRealityPhoto", "objectFinder"].includes(task.answerType)
      }))
      .filter(task => task.isMediaType);
  }

  startSlideshow() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    }

    this.$router.push(`/${vxm.results.eventId}/slideshow`);
  }

  get tasksFilter() {
    return vxm.results.mediaTasksFilter;
  }

  set tasksFilter(value) {
    vxm.results.mediaTasksFilter = value;
  }

  get teamsFilter() {
    return vxm.results.mediaTeamsFilter;
  }

  set teamsFilter(value) {
    vxm.results.mediaTeamsFilter = value;
  }

  get sortBy() {
    return vxm.results.mediaSortBy;
  }

  set sortBy(value) {
    vxm.results.mediaSortBy = value;
  }

  async requestMediaArchive(mediaType: MediaType, reset = true) {
    if (reset) {
      mediaType.archiveStatus = "requesting";
    }

    try {
      const { data } = await api.get(`v4/games/${vxm.results.gameId}/media-archive`, {
        params: { contentType: mediaType.queryParameter }
      });
      mediaType.archiveStatus = data.status;
      mediaType.archiveProgress = Math.floor((data.processedFiles / (data.totalFiles + 1)) * 100) + "%";
      mediaType.archiveUrl = data.url;

      if (data.status === "processing") {
        mediaType.timeout = setTimeout(() => this.requestMediaArchive(mediaType, false), 5000);
      }
    } catch (err) {
      mediaType.archiveStatus = "failed";
      mediaType.archiveMessage = "Request failed, please try again later";

      if ((err as any).response?.data?.message) {
        mediaType.archiveMessage = (err as any).response.data.message;
      }
    }
  }

  get isInstructor() {
    return vxm.results.isInstructor;
  }

  get publicResults() {
    return vxm.results.game.publicResults.includes("photos") || vxm.results.isInstructor;
  }

  // Clear timeouts when the component is destroyed to avoid memory leaks
  destroyed() {
    this.mediaTypes.forEach(mediaType => {
      clearTimeout(mediaType.timeout);
    });
  }
  get availableMediaTypes() {
    return this.mediaTypes.filter(mediaType =>
      this.media.some(item => {
        if (!item.type) return false; // Ensure type exists

        if (mediaType.queryParameter === "images") {
          return item.type.startsWith("image"); // Matches "image/jpeg", "image/png", etc.
        } else if (mediaType.queryParameter === "videos") {
          return item.type.startsWith("video"); // Matches "video/mp4", "video/webm", etc.
        }
        return false;
      })
    );
  }
}
